import { render } from "./formDialog.vue?vue&type=template&id=72557e78&scoped=true"
import script from "./formDialog.vue?vue&type=script&lang=js"
export * from "./formDialog.vue?vue&type=script&lang=js"

import "./formDialog.vue?vue&type=style&index=0&id=72557e78&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72557e78"]])

export default __exports__